import { IUser } from '../../shared/typings/interfaces/user.interface';
import * as currentUserActions from '../actions/current-user-actions';

export interface ICurrentUserState {
  loading: boolean;
  loaded: boolean;
  userEntity: IUser;
}

export const initialState: ICurrentUserState = {
  loading: false,
  loaded: false,
  userEntity: null,
};

export function reducer(
  state: ICurrentUserState = initialState,
  action: currentUserActions.CurrentUserAction,
): ICurrentUserState {
  switch (action.type) {
    case currentUserActions.LOAD_CURRENT_USER:
      return {
        ...state,
        loading: true,
      };
    case currentUserActions.LOAD_CURRENT_USER_SUCCESS:
      const userEntity = action.payload;
      return {
        ...state,
        loading: false,
        loaded: true,
        userEntity,
      };
    default:
      return state;
  }
}
